import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomSteps from '../../../../../v2-components/Antd/Steps';
import { typeRetirement } from '../../../../reserve/reserve-detail/components/ReserveProgress/handle/type-retirement.handle';
import { status } from './constants/status.constant';
import { handleDescription } from './handle/description.handle';
import { orderInfoAdapter } from './handle/order-info-adapter.handle';
import { trackingInfoAdapter } from './handle/tracking-info-adapter.handle';

export default function TrackingProgress(props) {
	console.log('entro al trackingProgress',props);

	const adapterTracking = trackingInfoAdapter(props.data?.tracking?.[0]);
	const adapterOrder = orderInfoAdapter(props.data?.order?.[0]);
	const progress = adapterTracking.process;

	const filteredStatus = status[Enviroment.LANGUAGE].filter((s) => progress.some((p) => p.status === s.status));

	const steps = filteredStatus.map((item, index) => {
		const description = progress.filter((item) => item.status === filteredStatus[index].status);
		return {
			title: item.description,
			description: handleDescription(description),
		};
	});

	const current = steps.length - 1;

	return (
		<>
			<h4>{typeRetirement[Enviroment.LANGUAGE][adapterOrder.type_retirement]}</h4>
			<p>
				Farmacia {adapterOrder.info.pharmacy ==='fanich' ? 'La Botica Anich' : adapterOrder.info.pharmacy}, {adapterOrder.info.direction}, {adapterOrder.info.commune}, {adapterOrder.info.region}
			</p>
			<h2>Tracking de pedido</h2>
			<CustomSteps progressDot size="small" direction="vertical" current={current} items={steps} />
		</>
	);
}
